export const injectStylesheets = (shadowRoot) => {
  const REACT_APP_URL = process.env.REACT_APP_URL;
  const stylesheets = [
    "/swiper-bundle.min.css",
    "/ReactToastify.min.css",
    "/InnerImageZoom.min.css",
    "/Calendar.css",
  ];

  stylesheets.forEach((cssFile) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `${REACT_APP_URL}${cssFile}`;
    shadowRoot.appendChild(link);
  });
};

export const loadCSS = async (shadowRoot, baseUrl) => {
  try {
    const response = await fetch(`${baseUrl}/asset-manifest.json`);
    const manifest = await response.json();
    const cssFile = manifest.files["main.css"];
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `${baseUrl}/${cssFile}`;
    shadowRoot.appendChild(link);
  } catch (error) {
    console.error("Error loading CSS:", error);
  }
};

export const injectAccessibilityStyles = (shadowRoot) => {
  const style = document.createElement("style");
  style.textContent = `
    /* TEXT SIZE */
    [textSize="0"] {
     --font-size: 18px;
     --line-height: 25px;
     }
    [textSize="1"] {
   --font-size: 20px;
   --line-height: 27px;
   }
    [textSize="2"] {
   --font-size: 22px;
   --line-height: 30px;
   }
   [textSize="3"] {
   --font-size: 24px;
   --line-height: 32px;
   }
   [textSize="4"] {
   --font-size: 26px;
   --line-height: 34px;
   }
   [textSize] h1,
   [textSize] h2,
   [textSize] h3,
   [textSize] h4,
   [textSize] h5,
   [textSize] h6,
   [textSize] p,
   [textSize] span,
   [textSize] label,
   [textSize] button,
   [textSize] ul,
   [textSize] li,
   [textSize] a {
   font-size: var(--font-size) !important;
   line-height: var(--line-height) !important;
   }
 
 
    /* TEXT ALIGNMENT */
   [textAlignment="1"] * { text-align: left !important; justify-content: left !important; }
   [textAlignment="2"] * { text-align: center !important;  justify-content: center !important;}
   [textAlignment="3"] * { text-align: right !important; justify-content: right !important; }
   [textAlignment="4"] * { text-align: justify !important; }
     [textAlignment="1"] .heading-underline::after {
      left: 0;
      right: auto;
      margin: 0;
     }
     [textAlignment="2"] .heading-underline::after {
      left: 50%;
      transform: translateX(-50%);
      right: auto;
     }
     [textAlignment="3"] .heading-underline::after {
      right: 0;
      left: auto;
      margin: 0;
     }
 
 
     /* TEXT SPACING */
     [textSpacing="1"] * { word-spacing: 2px; }
     [textSpacing="2"] * { word-spacing: 4px; }
     [textSpacing="3"] * { word-spacing: 6px; }
 
     /* LINE SPACING */
     [lineSpacing="1"] * { line-height: 1.5 !important; }
     [lineSpacing="2"] * { line-height: 2 !important; }
     [lineSpacing="3"] * { line-height: 2.5 !important; }
 
     /* DAY MODE */
     [nightMode="1"] {
       background-color: #EFEFEF !important;
       color: #222 !important;
     }
     [nightMode="1"] * {
     background-color: transparent !important;
     color: inherit !important;
     border-color: #ccc !important;
     }
     [nightMode="1"] button {
     background-color: #EFEFEF !important;
     color: #222 !important;
     box-shadow: none !important;
     }
     [nightMode="1"] input,
     [nightMode="1"] textarea,
     [nightMode="1"] select {
     background-color: #EFEFEF !important;
     color: #222 !important;
     border: 1px solid #ccc !important;
     }
     /* NIGHT MODE */
     [nightMode="2"] {
     background-color: #121212 !important;
     color: #f1f1f1 !important;
     }
     [nightMode="2"] * {
     background-color: transparent !important;
     color: inherit !important;
     border-color: #333 !important;
     }
     [nightMode="2"] button {
     background-color: #1f1f1f !important;
     color: #fff !important;
     border: 1px solid #444 !important;
     box-shadow: none !important;
     }
     [nightMode="2"] input,
     [nightMode="2"] textarea,
     [nightMode="2"] select {
     background-color: #1e1e1e !important;
     color: #eee !important;
     border: 1px solid #444 !important;
     }
 
     /* CONTRAST */
     [contrast="1"] * { filter: contrast(125%); }
     [contrast="2"] * { filter: contrast(150%); }
 
     /* DISPLAY SIZE */
     [displaySize="1"] { transform: scale(1.05); transform-origin: top left; }
 
     /* IMAGE HIDE */
     [image="1"] img { display: none !important; }
 
     /* LINK STYLES */
     [link="1"] a { text-decoration: underline dotted; color: blue; }
 
     /* ANIMATION DISABLE */
     [animation="1"] * {
       animation: none !important;
       transition: none !important;
     }
  
     /* POINTER SIZE */
       [pointersize="1"] *,
       [pointersize="1"] a,
       [pointersize="1"] label,
       [pointersize="1"] button,
       [pointersize="1"] cursor-pointer,
       [pointersize="1"] label img {
           cursor: unset !important;
       }
  
       [pointersize="3"] *,
       [pointersize="2"] a,
       [pointersize="2"] label,
       [pointersize="2"] button,
       [pointersize="2"] cursor-pointer,
       [pointersize="2"] label img {
           cursor: unset !important;
       }
  
       [pointersize="3"] *,
       [pointersize="3"] a,
       [pointersize="3"] label,
       [pointersize="3"] button,
       [pointersize="3"] cursor-pointer,
       [pointersize="3"] label img {
           cursor: unset !important;
       }
       /* SCREEN READER */
       [read="1"] *,
       [read="1"] a,
       [read="1"] label,
       [read="1"] button,
       [read="1"] cursor-pointer,
       [read="1"] label img
       { cursor: unset !important; }
   `;
  shadowRoot.appendChild(style);
};

export const setupAccessibilitySync = (element) => {
  const syncAttrs = () => {
    const settings =
      JSON.parse(localStorage.getItem("easy-vision-user-settings") || "{}")
        ?.settings || {};
    Object.entries(settings).forEach(([key, val]) => {
      if (val) element.setAttribute(key, val.toString());
      else element.removeAttribute(key);
    });
  };

  syncAttrs();
  window.addEventListener("storage", (e) => {
    if (e.key === "easy-vision-user-settings") syncAttrs();
  });
  setInterval(syncAttrs, 100);
};
